import React from 'react';
import { Typography } from '@mui/material';
import { OrderInfo, RentalLinkInfo } from 'common/types';
import { useTranslation } from 'services/localization';

interface Props {
	rentalInfo: OrderInfo;
	dataQA?: string;
}
const RentalCardShoppers = (props: Props) => {
	const { rentalInfo, dataQA } = props;
	const { t } = useTranslation();

	const responsiblePerson = rentalInfo.responsiblePerson;
	const responsiblePersonDetails = responsiblePerson.external && responsiblePerson.person;
	const shopperNames =
		rentalInfo.shopperNames && rentalInfo.shopperNames.filter((name) => Boolean(name));
	const rentalLink = rentalInfo.rentalLink;

	const renderRentalShoppersAmount = () => {
		const shopperAmount = Object.keys(props.rentalInfo.shopperIdsWithProducts).length;
		return (
			<Typography variant={'body2'} color="textSecondary">
				{shopperAmount +
					' ' +
					(shopperAmount > 1 ? t('rentalCard.people', 'people') : t('rentalCard.person', 'person'))}
			</Typography>
		);
	};

	const renderRentalLink = (rentalLink: RentalLinkInfo) => {
		const { firstName, lastName, email, phone } = rentalLink;
		return (
			<Typography variant="h5">
				{firstName || lastName
					? firstName
						? firstName
						: ' ' + lastName
						? lastName
						: ''
					: email
					? email
					: phone
					? phone
					: ''}
			</Typography>
		);
	};

	return (
		<div data-sl="mask">
			{shopperNames.length ? (
				<Typography variant={'h5'} data-qa={props.dataQA}>
					{shopperNames[0]}
				</Typography>
			) : responsiblePersonDetails ? (
				<Typography variant={'h5'} data-qa={dataQA}>
					{responsiblePersonDetails.firstName + ' ' + responsiblePersonDetails.lastName}
				</Typography>
			) : rentalLink ? (
				renderRentalLink(rentalLink)
			) : null}
			{renderRentalShoppersAmount()}
		</div>
	);
};

export default RentalCardShoppers;
